


// Generated from io.spcfy.projects.evaluation.GroupMode

export type GroupModeKey =
  "PROCESS_ID" |
  "BIN" |
  "FAMILY" |
  "GENUS" |
  "SPECIES" |
  "NONE";


export interface GroupModeDTO {
  key: GroupModeKey;
  label: string;    
}


export const GroupModes: Record<GroupModeKey, GroupModeDTO> = {
  PROCESS_ID: { key: "PROCESS_ID", label: "Process ID" },
  BIN: { key: "BIN", label: "Bin" },
  FAMILY: { key: "FAMILY", label: "Family" },
  GENUS: { key: "GENUS", label: "Genus" },
  SPECIES: { key: "SPECIES", label: "Species" },
  NONE: { key: "NONE", label: "OTUs" }
};
